import React, { useEffect } from "react";
import styles from "./LineUp.module.scss";
import {
  CurrentChatStatus,
  Message,
  MessageSender,
  MessageType,
} from "@/app/store/types";
import { tryParse } from "@/app/utils/object";
import SemiButton from "@/app/ui/button";
import { webSocketService } from "@/app/services/WebSocketService";
import { isMobileDevice } from "@/app/utils/device";
import { useMessageStore } from "@/app/store";
import { cancelQueue } from "@/app/api/message";
import { ScrollAction, ScrollFrom } from "@/app/hooks/useReadScrollToBottom";
import Locale from "@/app/locales";
import { ReportScene, reportScene } from "@/app/services/DataReporter";
interface IProps {
  msg: Message;
}
export default function LineUp(props: IProps) {
  const content = props.msg?.content as string;
  const chatStatus = useMessageStore((state) => state.chatStatus);

  useEffect(() => {
    props.msg.handleScrollToBottom?.(
      ScrollAction.FORCE_TO_BOTTOM,
      ScrollFrom.LINE_UP,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!content || chatStatus !== CurrentChatStatus.LineUp) {
    return;
  }

  const getLineInfo = () => {
    let { text } = tryParse(content) || {};
    text = text.replace(/\d+/g, (num: number) => {
      return `<span style="color:#00ae42; font-weight: bold; margin: 0 4px">${num}</span>`;
    });
    return text;
  };

  const handleCancelLineUp = async () => {
    reportScene(ReportScene.CANCEL_LINE_UP);
    await cancelQueue();
    webSocketService.sendMessage(
      JSON.stringify({ text: Locale.chat.canceledLineUp }),
      {
        noNeedSendToWebsocket: true,
        senderType: MessageSender.USER,
        msgType: MessageType.Template,
      },
    );
  };

  return (
    <div
      className={`${styles.lineUp} ${isMobileDevice() ? styles.mobile : ""}`}
    >
      <p
        className={styles.title}
        dangerouslySetInnerHTML={{ __html: getLineInfo() }}
      ></p>
      <SemiButton
        onClick={handleCancelLineUp}
        theme="borderless"
        className={styles.cancel}
        extraclassname="extra"
      >
        {Locale.chat.cancelLineUp}
      </SemiButton>
    </div>
  );
}
